import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import BlurOnIcon from '@material-ui/icons/BlurOn';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../../core/style/gstheme';
import VisualisationContainer from './VisualisationContainer';

const styles = Object.assign({
    visualisationContent: {
        padding: '0px'
    }
}, globalStyles);

class ResourceVisualisationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    exitVisualisation = () => this.setState({
        open: false
    });

    render() {

        const { classes, sourceNode, graph, defaultLang, viewLang, objectPropertyConfiguration, ontologyProjects,
            displayClasses, associatedProject } = this.props;
        const { open } = this.state;

        return (
            <React.Fragment>
                <span onClick={this.handleClickOpen}>
                    <Tooltip placement="right" title='Visualise'>
                        <IconButton
                            aria-label="Show visualisation"
                            data-test="show-visualisation"
                            size="small"
                            className={classes.addButton}>
                            <BlurOnIcon />
                        </IconButton>
                    </Tooltip>
                </span>
                {open &&
                    <Dialog classes={{
                        root: classes.visualisationDialog,
                        paper: classes.visualisationDialogPaper
                    }}
                        fullScreen={true}
                        data-test="resource-visualisation"
                        open={this.state.open}
                        onClose={this.exitVisualiation}
                        aria-labelledby="visualisation-dialog-title">
                        <DialogContent style={{ paddingTop: 0 }} classes={{
                            root: classes.visualisationContent
                        }}>
                            <div style={{ padding: 0, height: 'calc(100% - 4px)' }}>
                                <VisualisationContainer
                                    onLoadResource={this.onLoadResource}
                                    associatedProject={associatedProject}
                                    ontologyProjects={ontologyProjects}
                                    objectPropertyConfiguration={objectPropertyConfiguration}
                                    displayClasses={displayClasses}
                                    sourceNode={sourceNode}
                                    graph={graph}
                                    exitVisualisation={this.exitVisualisation}
                                    defaultLang={defaultLang}
                                    viewLang={viewLang}
                                />
                            </div>
                        </DialogContent>
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

ResourceVisualisationDialog.propTypes = {
    classes: PropTypes.object,
    sourceNode: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    associatedProject: PropTypes.array,
    ontologyProjects: PropTypes.array,
    objectPropertyConfiguration: PropTypes.object.isRequired,
    displayClasses: PropTypes.object.isRequired,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string.isRequired
};

export default withStyles(styles)(ResourceVisualisationDialog);